document.addEventListener('tagalys:ready', () => {
  window.Tagalys.setConfiguration({
    api: {
      serverUrl: window.theme.tagalys.apiUrl,
      credentials: {
        clientCode: window.theme.tagalys.clientCode,
        apiKey: window.theme.tagalys.apiKey,
      },
      storeId: window.theme.tagalys.storeId,
    },
    currency: {
      code: window.Shopify.currency.active,
      fractionalDigits: window.Shopify.currency.rate,
    },
    platform: 'shopify',
    track: true,
    analyticsStorageConsentProvided () {
      return window.OptanonActiveGroups?.indexOf('C0004') > -1
    },
  })

  if (window.theme.product) {
    TagalysProductRecommendations()
  }

  TagalysCartRecommendations()

  window.BAO.eventBus.addEventListener(
    window.BAO.EVENTS.PUSH_CART.CHANGED,
    TagalysCartRecommendations,
  )
})

function TagalysProductRecommendations () {
  window.Tagalys.APIConnector.Recommendations.call({
    params: {
      recommendationId: window.theme.tagalys.additionalColorsId,
      productId: window.theme.product.id,
    },
    onSuccess (response) {
      const isSuccessful = response.products.length > 0

      const customEvent = new CustomEvent(
        'productAdditionalColorsDataIsReady',
        {
          bubbles: true,
          detail: {
            successful: isSuccessful,
            data: response.products,
          },
        },
      )

      // Dispatch the event.
      window.dispatchEvent(customEvent)
    },
    onFailure (response) {
      const customEvent = new CustomEvent(
        'productAdditionalColorsDataIsReady',
        {
          bubbles: true,
          detail: {
            successful: false,
            data: response.products,
          },
        },
      )
      window.dispatchEvent(customEvent)
    },
  })

  window.Tagalys.APIConnector.Recommendations.call({
    params: {
      recommendationId: window.theme.tagalys.recommendedId,
      productId: window.theme.product.id,
    },
    onSuccess (response) {
      const isSuccessful = response.products.length > 0
      const customEvent = new CustomEvent('productRecommendationsDataIsReady', {
        bubbles: true,
        detail: {
          successful: isSuccessful,
          data: response.products,
        },
      })

      // Dispatch the event.
      window.dispatchEvent(customEvent)

      if (!isSuccessful) {
        return
      }

      const initialiseCarousel = new CustomEvent('initialiseCarousel', {
        bubbles: true,
      })

      window.dispatchEvent(initialiseCarousel)
    },
    onFailure (response) {
      const customEvent = new CustomEvent('productRecommendationsDataIsReady', {
        bubbles: true,
        detail: {
          successful: false,
          data: response.products,
        },
      })
      window.dispatchEvent(customEvent)
    },
  })
}

function TagalysCartRecommendations () {
  if (!window.theme.tagalys.cartRecommendationsId) return

  window.Tagalys.APIConnector.SmartWidget.call({
    params: {
      widgetId: window.theme.tagalys.cartRecommendationsId,
    },
    onSuccess (response) {
      const isSuccessful = response.products.length > 0

      const customEvent = new CustomEvent('cartRecommendationsDataIsReady', {
        bubbles: true,
        detail: {
          successful: isSuccessful,
          data: response.products,
        },
      })

      window.dispatchEvent(customEvent)
    },
    onFailure (response) {
      console.error(response)
    },
  })
}
